<template>
  <div class="container-xxl" v-if="!loading">
    <div class="row justify-content-center m-2">
      <div class="col-12 col-sm-8 mt-3 mb-3">
        <h1 class="py-3">Choose from a park below to see the ride wait times and availability for each land.</h1>
      </div>
    </div>
    <!-- card looping through the companies -->
    <div class="row justify-content-center mt-4 mb-4">
      <div class="col-12 col-sm-6" v-for="park in land.parks">
        <router-link :to="{ name: 'park', params: { companySlug: this.$route.params.companySlug, parkSlug: park.name.replace(/\s+/g, '-').replace(/'/g, '').replace(/,/g, '').replace(/\(/g, '').replace(/\)/g, '').replace('.', '').toLowerCase() }} ">
          <div class="card rounded-4 cards mb-5">
<!--            <div v-if="land.name === 'Walt Disney Attractions'">-->
<!--              <img src="img/mickey-peeking-top.png" class="mickey-peak" alt="Mickey Mouse peaking over the top of a grey card">-->
<!--            </div>-->
<!--            <div v-else-if="land.name === 'Universal Parks & Resorts'">-->
<!--              <img src="img/maggie-peek.png" class="maggie-peak" alt="Maggie from the Simpsons lying on top of a grey card">-->
<!--            </div>-->
            <div class="row g-0 justify-content-center m-3">
              <div class="col-md-3 mt-3 mb-3 px-3 py-1">
<!--                <img :src="'/img/parks/' + park.name.replace(/ /g, '-').replace(/'/g, '').replace(/,/g, '').replace('.', '').toLowerCase() + '.png'"  :alt="`${park.name.replace(/\b\w/g, char => char.toUpperCase()) } logo`">-->
              </div>
              <div class="col-md-9 my-auto">
                <div class="card-body py-2">
                  <h3 class="card-title text-center text-sm-end m-auto">{{ park.name }}</h3>
                  <div v-if="park.country === 'United States'" class="text-end py-2">
                    <img src="/img/mickey-mouse-american-flag.svg" class="country-flag img-fluid rounded-2" alt="American flag icon with white Mickey Mouse outlines replacing the stars">
                  </div>
                  <div v-else class="text-end py-2">
                    <img src="/img/france.svg" class="country-flag img-fluid rounded-2" alt="French flag">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
  <div v-else class="text-center">
    <div role="status" class="spinner-border text-center mt-4"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      land: {},
      parks: [],
      loading: true
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      axios.get('/api/parks.json').then(response => {
        this.loading = false;

        for (let i = 0; i < response.data.length; i++) {
          if (this.$route.params.companySlug === response.data[i].name.replace(/ /g, '-').replace(/&/g, 'and').toLowerCase()) {
            this.land = response.data[i];
            // Remove parks with specific IDs
            if (this.land.id === 2) {
              const parksToRemove = [30,31,274,275];
              this.land.parks = this.land.parks.filter(park => !parksToRemove.includes(park.id));

              console.log(this.land);

            } else if (this.land.id === 12) {
              const parksToRemove = [328,284];
              this.land.parks = this.land.parks.filter(park => !parksToRemove.includes(park.id));
            }
            break;
          }
        }
        this.lands = response.data;
        // console.log(this.lands)
        this.lands.forEach(function (land) {
          land.slug = land.name.replace(/ /g, '-').toLowerCase();
          // land.slug = land.name.replace(/&/g, '').replace(/ /g, '-').replace(/--/g, '-').toLowerCase();
        });
      }).catch(error => {
        console.error('unable to retrieve the list of lands');
      });
    }
  }
}
</script>